import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
	public clientCode : string;
	
	constructor(
		private renderer: Renderer2,
		private router: Router
	) { }

	ngOnInit(): void {
		this.setBGColor();
	}
	
	startQuestions () {
		if (this.clientCode) {
			this.router.navigate(['start/'+this.clientCode+'']);	
		} else {
			this.router.navigate(['start']);
		}
	}
	
	setBGColor() {
		let shuffleColors = ["#7E78B8", "#F06793", "#FCBA63", "#51BF9D", "#44C8F5"];
		let chooseRandomColor = Math.floor(Math.random() * shuffleColors.length);
		
		this.renderer.setStyle(document.body, 'background-color', shuffleColors[chooseRandomColor]);
	}

	formatInput(input) {
		this.clientCode = input.toLowerCase().replace(/\s/g, "");
	}
}
